import { render, staticRenderFns } from "./withdrawalsRecord.vue?vue&type=template&id=83f7d268&scoped=true&"
import script from "./withdrawalsRecord.vue?vue&type=script&lang=js&"
export * from "./withdrawalsRecord.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalsRecord.vue?vue&type=style&index=0&id=83f7d268&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f7d268",
  null
  
)

export default component.exports